import _ from 'lodash';
import HelperValidate from "utils/helper-validate";

const HelperCollection = {
	
	filterEmpty: ( array, p ) => {
		return _.filter( array, (o) => {
			return HelperValidate.isValid( _.get( o, p, '' ) );
		});
	},
	
	filterWithoutGuid: ( array ) => {
		return HelperCollection.filterEmpty( array, 'guid' );
	},
	
	removeEmpty: ( collection ) => {
		return _.filter( collection, ( o ) => {
			return HelperValidate.isValid( o );
		})
	}
}

export default HelperCollection
